import { createHttpClient } from '@vista-digital/http-client';
import { nanoid } from 'nanoid';
import { loadScripts } from '../utils/load-script';
import { logger } from '../utils/logger';
import { validateParams } from '../utils/validate-params';
import { AddPaymentCardError } from './types/add-payment-card-error';
import { AddPaymentCardErrorResultCode } from './types/add-payment-card-error-result-code';
export class PaymentCardsClient {
    async initialiseConnector() {
        const { container , events  } = this.params;
        const { sdkScriptUrls , connectorScriptUrls , connectorFunctionName , connectorParametersJson , createCardTokenUrl , isButtonIncluded  } = await this.createPaymentCard();
        this.isButtonIncluded = isButtonIncluded;
        await loadScripts(sdkScriptUrls.concat(connectorScriptUrls));
        if (!window.vista.payments.connector[connectorFunctionName]) {
            throw new Error(`Failed to initialise connector. Function name '${connectorFunctionName}' not found.`);
        }
        const serverParams = JSON.parse(connectorParametersJson);
        container.innerHTML = '';
        const clientParams = {
            container: container,
            onCardProxyDataReceived: (data)=>this.handleCardProxyDataReceived(createCardTokenUrl, data)
            ,
            onError: (errorMessage)=>this.handleConnectorError(errorMessage)
            ,
            onPaymentMethodDeclined: (errorMessage)=>this.handleCardDeclined(errorMessage)
            ,
            onPaymentButtonStateChanged: (state)=>{
                events.onAddPaymentCardButtonStateChanged(state);
            },
            onPaymentStarted: ()=>events.onAddPaymentCardStarted()
        };
        this.paymentCardsGatewayUI = window.vista.payments.connector[connectorFunctionName](serverParams, clientParams);
    }
    unmount() {
        if (this.paymentCardsGatewayUI && typeof this.paymentCardsGatewayUI.unmount === 'function') {
            this.paymentCardsGatewayUI.unmount();
        }
        this.params.container.innerHTML = '';
    }
    async handleCardProxyDataReceived(createCardTokenUrl, data) {
        // Generate a unique ID for the PUT request so that it can be retried if necessary.
        const requestId = nanoid();
        const httpClient = createHttpClient({
            headers: new Headers({
                'Content-Type': 'application/json',
                'Vista-Payment-Request-Id': requestId
            })
        });
        try {
            const response = await httpClient.put(createCardTokenUrl, data, {
                parseResponse: false
            });
            if (response.status === 302) {
                // redirection
                response.text().then((result)=>document.write(result)
                );
            } else {
                this.handleAddPaymentCardAttempt(response);
            }
        } catch (e) {
            this.handleAddPaymentCardFailed(AddPaymentCardErrorResultCode.ApiError);
        }
    }
    constructor(params){
        this.startAddingPaymentCard = ()=>{
            var ref;
            (ref = this.paymentCardsGatewayUI) == null ? void 0 : ref.startPayment();
        };
        this.createPaymentCard = async ()=>{
            const { ocapiClient , webPaymentMethodId , redirectReturnUrl , languageTag  } = this.params;
            try {
                return await ocapiClient.v1.loyalty.members.paymentCards.createEmbedded({
                    webPaymentMethodId,
                    redirectReturnUrl,
                    languageTag
                });
            } catch (e) {
                throw new AddPaymentCardError(AddPaymentCardErrorResultCode.ApiError);
            }
        };
        this.handleAddPaymentCardAttempt = async (response)=>{
            if (response.status === 400) {
                return this.handleAddPaymentCardFailed(AddPaymentCardErrorResultCode.CardDeclined);
            }
            this.handleAddPaymentCardSuccessful(await response.json());
        };
        this.handleAddPaymentCardSuccessful = (card)=>{
            this.params.events.onAddPaymentCardSuccessful(card);
        };
        this.handleAddPaymentCardFailed = (resultCode)=>{
            this.params.events.onAddPaymentCardFailed(new AddPaymentCardError(resultCode));
        };
        this.handleConnectorError = (errorMessage)=>{
            logger.error(errorMessage);
            this.handleAddPaymentCardFailed(AddPaymentCardErrorResultCode.ConnectorError);
            throw new AddPaymentCardError(AddPaymentCardErrorResultCode.ConnectorError);
        };
        this.handleCardDeclined = (errorMessage)=>{
            logger.error(errorMessage);
            this.handleAddPaymentCardFailed(AddPaymentCardErrorResultCode.CardDeclined);
            throw new AddPaymentCardError(AddPaymentCardErrorResultCode.CardDeclined);
        };
        const requiredParams = [
            'container',
            'childContainerClassName',
            'events',
            'ocapiClient'
        ];
        const valid = validateParams(params, requiredParams);
        if (!valid) throw new Error('Failed to create PaymentCardsClient. Missing required params.');
        this.params = params;
    }
}

//# sourceMappingURL=payment-cards-client.js.map